import { Form } from "@circle-react-uikit/Form";
import { ImagePicker } from "../ImagePicker";

export interface ImagePickerFieldProps {
  label: string;
  name: string;
  shouldAllowRemovingImage?: boolean;
}

export const ImagePickerField = ({
  name,
  label,
  shouldAllowRemovingImage,
}: ImagePickerFieldProps) => (
  <Form.Item
    name={name}
    label={label}
    hideDescription
    hideBorder
    labelClassName="!font-normal text-xs"
    className="!p-0"
  >
    <ImagePicker
      name={name}
      shouldAllowRemovingImage={!!shouldAllowRemovingImage}
    />
  </Form.Item>
);
